import { useAdministrativeContext } from '../../../../../../pages/administrativePanel/administrativePanelContext'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { SpaceLoader } from '../../../../../loaders/spaceLoader'
import { formatMoney } from '../../../../../../Utils/formatMoney'
import { api } from '../../../../../../services/api'
import { useState, useEffect, useCallback } from 'react'
import { useAuth } from '../../../../../../context/AuthContext'
import { toast } from 'react-toastify'

import { TooltipContent } from './style'



export function MonthBalance({ isMonthBalance }) {
    const [monthBalance, setMonthBalance] = useState([])
    const [isLoading, setIsLoading] = useState(true)
  
    const { 
      listBusinessToFilter, 
      listSalesChannelsId 
    } = useAdministrativeContext()
  
  
    const { signOut } = useAuth()
  
  
    const fetchData = useCallback(async () => {
      setIsLoading(true)
      let obj = {
        month: isMonthBalance.month,
        business: listBusinessToFilter,
        salesChannels: listSalesChannelsId
      }

        try{
            await api.post('/getBalanceDays' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setMonthBalance(response.data))
  
            setIsLoading(false)
  
        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                  signOut()
                  toast.warning('Sua sessão foi expirada')
                }else{
                  toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [signOut, listBusinessToFilter, isMonthBalance, listSalesChannelsId])
  
    
    useEffect(() =>{
        fetchData()
  
        return () => {
            setMonthBalance([])
        }
  
    }, [fetchData])

   


    const renderCustomAxisTick = ({ x, y, payload }) => {
      const day = Number(isMonthBalance.month.slice(0, 2)) - 1
      const year = Number(`20${isMonthBalance.month.slice(3)}`)
      const options = { weekday: 'long'}
      const weekDay = new Date(year, day , payload.value).toLocaleDateString('pt-BR', options).slice(0, 3).toUpperCase()

      return (
        <>
          <text   
            x={x - 5} 
            y={y + 4} 
            fill="#666" 
            fontSize="0.75rem"
          >{payload.value}</text>
          <text
            x={x - 8} 
            y={y + 15} 
            fill="#666" 
            fontSize="0.5rem"
          >{weekDay}</text>
        </>
      )
    }

   
    if(isLoading)
        return  <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/> 
      
      return(
        <>
          {
            monthBalance.length > 0 ?
              <ResponsiveContainer  
                  width="90%" 
                  height="100%"
                  maxHeight={700}
              >

                      <BarChart 
                        data={monthBalance} 
                        margin={{top: 30}}
                      >

                          
                          <Tooltip  
                              content={<CustomTooltip />}
                          /> 
                          

                          <XAxis 
                              dataKey="day" 
                              axisLine={false} 
                              tickLine={false} 
                              stroke="var(--colorFontsCardsDashboard)" 
                              tick={renderCustomAxisTick}
                          />

                          <YAxis 
                              axisLine={false} 
                              tickLine={false} 
                              tickCount={6} 
                              width={65}
                              fontSize="0.85rem" 
                              stroke="var(--colorFontsCardsDashboard)" 
                              tickFormatter={number => (
                                  number >= 1000 && number < 1000000 ? `R$${number/1000}K` : 
                                  number >= 1000000 && number < 1000000000 ? `R$${number/1000000}M` :
                                  number >= 1000000000 ? `R$${number/1000000000}B` :      
                                  `R$${number.toFixed(2)}`
                              )} 
                          />

                          <Bar 
                              dataKey="credits" 
                              fill="#2e9699"  
                          />


                          <CartesianGrid 
                              opacity={0.2} 
                              vertical={false} 
                              stroke="var(--colorFontsCardsDashboard)" 
                          />


                      </BarChart>

              </ResponsiveContainer>
              :<p>Nenhuma informação</p>
          } 
        </>
      )
}



export function CustomTooltip({ active, payload, label }) {
    if(active){
      return(
        <TooltipContent>
  
          <h4>{label}</h4>
          {payload?.map((information, index) =>(
            <p key={index}>
             { formatMoney(information.value) }
            </p>
          ))}
          
        </TooltipContent>
      )
    }
    return null
}

